import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WebSocketState {
  isConnected: boolean;
  lastUpdate: string | null;
  data: any;
  error: string | null;
}

const initialState: WebSocketState = {
  isConnected: false,
  lastUpdate: null,
  data: null,
  error: null,
};

const websocketSlice = createSlice({
  name: "websocket",
  initialState,
  reducers: {
    setConnectionStatus: (state, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    updateData: (state, action: PayloadAction<any>) => {
      state.data = action.payload;
      state.lastUpdate = new Date().toISOString();
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setConnectionStatus, updateData, setError, clearError } =
  websocketSlice.actions;
export default websocketSlice.reducer;
